export function formatOrgDisplayName(input: string): string {
  const normalized = input.replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
  if (!normalized) return input;

  return normalized
    .split(' ')
    .map((word) => {
      if (!word) return word;
      if (!/[A-Za-z]/.test(word)) return word;

      // Keep short acronyms (AI, CS, etc) as-is.
      if (word === word.toUpperCase() && word.length <= 3) {
        return word;
      }

      const first = word[0].toUpperCase();
      const rest = word.slice(1).toLowerCase();
      return first + rest;
    })
    .join(' ');
}
